import { useState, useEffect } from "react";

const TOAST_LIMIT = 1;
let count = 0;
function generateId() {
  count = (count + 1) % Number.MAX_VALUE;
  return count.toString();
}

const toastStore = {
  state: { toasts: [] },
  listeners: [],
  getState: () => toastStore.state,
  setState: (nextState) => {
    toastStore.state =
      typeof nextState === "function"
        ? nextState(toastStore.state)
        : { ...toastStore.state, ...nextState };
    toastStore.listeners.forEach((l) => l(toastStore.state));
  },
  subscribe: (listener) => {
    toastStore.listeners.push(listener);
    return () => {
      toastStore.listeners = toastStore.listeners.filter((l) => l !== listener);
    };
  },
};

export const toast = (props) => {
  const id = generateId();
  const update = (props) =>
    toastStore.setState((s) => ({
      ...s,
      toasts: s.toasts.map((t) => (t.id === id ? { ...t, ...props } : t)),
    }));
  const dismiss = () =>
    toastStore.setState((s) => ({
      ...s,
      toasts: s.toasts.filter((t) => t.id !== id),
    }));
  toastStore.setState((s) => ({
    ...s,
    toasts: [{ ...props, id, dismiss }, ...s.toasts].slice(0, TOAST_LIMIT),
  }));
  return { id, dismiss, update };
};

export function useToast() {
  const [state, setState] = useState(toastStore.getState());
  useEffect(() => toastStore.subscribe((s) => setState(s)), []);
  useEffect(() => {
    const timers = [];
    state.toasts.forEach((t) => {
      if (t.duration === Infinity) return;
      const timeout = setTimeout(() => t.dismiss(), t.duration || 5000);
      timers.push(timeout);
    });
    return () => timers.forEach(clearTimeout);
  }, [state.toasts]);
  return { toast, toasts: state.toasts };
}
